<template>
  <v-checkbox
    v-bind="vuetifyOverrideMixin.bindings"
    class="sn-checkbox"
    :class="{ 'sn-checkbox-simple': simple }"
    v-on="$listeners"
  >
    <!-- Pass on all named slots -->
    <slot
      v-for="slot in Object.keys($slots)"
      :slot="slot"
      :name="slot"
    />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-checkbox>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnCheckbox',
  mixins: [vuetifyOverrideMixin],
  // v-checkbox uses 'change' instead of the default 'input' event, and `input-value` instead of the default `value` prop to track model changes
  // See https://github.com/vuetifyjs/vuetify/blob/75404fb66e61d4b4d5b759506ac0d4c7a56a3755/packages/vuetify/src/mixins/selectable/index.ts#L23
  model: { prop: 'inputValue', event: 'change' },
  props: {
    simple: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          color: 'snBrand',
          hideDetails: 'auto',
          indeterminateIcon: '$snCheckBoxIndeterminate',
          offIcon: '$snCheckBox',
          onIcon: '$snCheckBoxSelected',
          persistentHint: true
        },
        overriddenProps: {
          // Supported props:
          /*
            disabled: false,
            error: false,
            errorMessages: [],
            falseValue: undefined,
            hint: undefined,
            id: undefined,
            indeterminate: false,
            inputValue: undefined,
            label: undefined,
            rules: [],
            trueValue: undefined,
            validateOnBlur: false,
            value: undefined
            valueComparator: null
          */

          appendIcon: undefined,
          backgroundColor: undefined,
          dark: false,
          dense: false,
          errorCount: 1,
          hideSpinButtons: false,
          light: false,
          messages: [],
          multiple: false,
          prependIcon: undefined,
          readonly: false,
          ripple: false, // On by default in Vuetify
          success: false,
          successMessages: []
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-checkbox {
  @extend .sn-selection;

  &.sn-checkbox-simple {
    @extend .sn-selection__simple;
  }

  &:not(.sn-checkbox-simple) {
    ::v-deep .v-input__slot {
      @extend .sn-selection__input;
    }

    &.v-input--is-label-active ::v-deep .v-input__slot {
      @extend .sn-selection__input-active;
    }
    &:not(.v-input--is-label-active) ::v-deep .v-input__slot {
      @extend .sn-selection__input-inactive;
    }
    &.error--text ::v-deep .v-input__slot {
      @extend .sn-selection__input-error;
    }
    &.v-input--is-disabled ::v-deep .v-input__slot {
      @extend .sn-selection__input-disabled;
    }
  }
}
</style>
